var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "remove",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e58675",
    d: "M6 19.17v7.71l1.45 1.74 4.02.71 12.01-.35 2.81-1.86-.7-2.87V7.01H6v12.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc4352",
    d: "M12 4h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2zm17 2H3a1 1 0 0 0 0 2h2v10.17a1 1 0 0 0 2 0V8h18v18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.33a1 1 0 0 0-2 0V26a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V8h2a1 1 0 0 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.ba2b1faadf5481dc1c9d043e7e26b333.svg";
export { ForwardRef as ReactComponent };